import axios from 'axios'
import _, { isEmpty } from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Card,
  Col,
  Empty,
  message,
  Modal,
  Row,
  Upload,
  Popconfirm
} from 'antd'
import styled from 'styled-components'
import { styles } from './styles'
import { compressFile } from '../../../../utils/services'
import {
  getHeroDetail,
  saveHeroIdCard,
  saveHeroDocument,
  deleteHeroImage
} from '../../../../modules/hero'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../../../utils/hooks'

const CloseButton = styled.span`
  position: absolute;
  top: -20px;
  right: 0px;
  z-index: 100;
  font-size: 40px;
  color: black;
  cursor: pointer;

  &:hover {
    color: red;
  }
`

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!')
  }
  return false
}

const Image = ({ data }) => {
  const dispatch = useDispatch()
  const { heroDetail, isLoading } = useSelector(
    (state) => ({
      heroDetail: state.hero.heroDetail,
      isLoading: state.hero.isLoading
    }),
    []
  )

  async function fetchData() {
    await dispatch(getHeroDetail(data.id))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  console.log(heroDetail)

  const handleUploadChange = async (info, type) => {
    // getBase64(info.file)
    const formData = new FormData()
    formData.append('image', await compressFile(info.file))

    if (type === 'idCard') {
      // await axios.post(
      //   `${process.env.REACT_APP_API_ENDPOINT}/hero/image-idcard`,
      //   formData,
      //   {
      //     headers: {
      //       'content-type': 'multipart/form-data'
      //     },
      //     params: {
      //       heroId: data.id
      //     }
      //   }
      // )
      await dispatch(saveHeroIdCard(formData, data.id))
      await dispatch(getHeroDetail(data.id))
    } else if (type === 'document') {
      if (data.pictures.length !== 5) {
        // await axios.post(
        //   `${process.env.REACT_APP_API_ENDPOINT}/hero/image-document`,
        //   formData,
        //   {
        //     headers: {
        //       'content-type': 'multipart/form-data'
        //     },
        //     params: {
        //       heroId: data.id
        //     }
        //   }
        // )
        await dispatch(saveHeroDocument(formData, data.id))
        await dispatch(getHeroDetail(data.id))
      } else {
        Modal.warning({
          content: 'ไม่สามารถอัพโหลดได้เกิน 5 รูป'
        })
      }
    }
  }

  const handleDeleteImage = async (e, imageId) => {
    e.preventDefault()
    const token = localStorage.getItem('user-token')
    // await axios.delete(
    //   `${process.env.REACT_APP_API_ENDPOINT}/hero/image-document`,
    //   {
    //     headers: {
    //       'content-type': 'multipart/form-data',
    //       Authorization: !_.isNull(token) ? token : ''
    //     },
    //     params: {
    //       heroId: data.id,
    //       imageId: imageId
    //     }
    //   }
    // )
    await dispatch(deleteHeroImage(data.id, imageId))
    await dispatch(getHeroDetail(data.id))
  }

  const cancel = (e) => {
    message.error('Canceled delete image')
  }

  return (
    <React.Fragment>
      <Card
        loading={isLoading}
        style={{ marginTop: 16 }}
        cover={
          <div style={styles.avatarWraper}>
            <Row type="flex" justify="center">
              <Col>
                <Upload
                  name="avatar"
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={(info) => handleUploadChange(info, 'idCard')}>
                  {!_.isNull(heroDetail.idCard) ? (
                    <img
                      src={heroDetail.idCard}
                      alt="avatar"
                      style={{ width: 500, height: 350 }}
                    />
                  ) : (
                    <Empty style={{ marginTop: 16 }} />
                  )}
                </Upload>
              </Col>
            </Row>
          </div>
        }>
        <Card.Meta title="ID Card" />
      </Card>

      <Card
        loading={isLoading}
        style={{ marginTop: 16 }}
        cover={
          !isEmpty(heroDetail.pictures) > 0 ? (
            <div>
              <Row style={{ marginBottom: 15 }}>
                {heroDetail.pictures.map((picture, index) => (
                  <Row key={picture.name}>
                    <Row
                      type="flex"
                      justify="center"
                      style={{ marginBottom: 5 }}>
                      <span
                        style={{
                          fontSize: 24
                        }}>{`รูปหน้าร้าน / รูปรถ / สถานที่ตั้ง ${
                        index + 1
                      }`}</span>
                    </Row>
                    <Row
                      type="flex"
                      justify="center"
                      style={{ marginBottom: 10 }}>
                      <div style={{ position: 'relative' }}>
                        <Popconfirm
                          title="คุณยืนยันจะลบรูปภาพใช่หรือไม่ ?"
                          onConfirm={(e) => handleDeleteImage(e, picture.id)}
                          onCancel={cancel}
                          okText="ใช่"
                          cancelText="ไม่">
                          <CloseButton
                          // onClick={(e) => handleDeleteImage(e, picture.id)}
                          >
                            &times;
                          </CloseButton>
                        </Popconfirm>

                        <img
                          src={picture.url}
                          alt="avatar"
                          style={{ width: 500, height: 350 }}
                        />
                      </div>
                    </Row>
                  </Row>
                ))}
              </Row>
              <Row type="flex" justify="center">
                <Upload
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={(info) => handleUploadChange(info, 'document')}>
                  <Button>Click to Upload</Button>
                </Upload>
              </Row>
            </div>
          ) : (
            <div>
              <Row type="flex" justify="center" style={{ marginTop: 16 }}>
                <Col>
                  <Upload
                    listType="picture-card"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={(info) => handleUploadChange(info, 'document')}>
                    <Empty />
                  </Upload>
                </Col>
              </Row>
            </div>
          )
        }>
        <Card.Meta title="Pictures" />
      </Card>
    </React.Fragment>
  )
}

Image.propTypes = {
  data: PropTypes.object.isRequired
}

export default Image
